import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EdgeNetworkComponent } from './edge-network.component';
const routes: Routes = [
  {
    path: '',
    component: EdgeNetworkComponent,
    title: 'edge-network'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EdgeNetworkRoutingModule { }
